import { render, staticRenderFns } from "./ClientProjects.vue?vue&type=template&id=dbe2286e&scoped=true&"
import script from "./ClientProjects.vue?vue&type=script&lang=js&"
export * from "./ClientProjects.vue?vue&type=script&lang=js&"
import style0 from "./ClientProjects.vue?vue&type=style&index=0&id=dbe2286e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe2286e",
  null
  
)

export default component.exports